import React from 'react';



const Sidebar = ({ isSidebarOpen, startNewChat }) => {
  return (
    <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <button className="new-chat-button" onClick={startNewChat}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Nova conversa
        </button>
      </div>

      <div className="chat-history">
        {/* Histórico (estático por enquanto) */}
        <div className="history-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          Conversa atual
        </div>
      </div>

      <div className="sidebar-footer">
        <span>Java Dev Assistant v1.0</span>
      </div>
    </div>
  );
};

export default Sidebar;
